export enum PlanEntryFinishedListingRequestOrder {
  DRIVER_ASC = "DRIVER_ASC",
  DRIVER_DESC = "DRIVER_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  TAXI_CORPORATION_ASC = "TAXI_CORPORATION_ASC",
  TAXI_CORPORATION_DESC = "TAXI_CORPORATION_DESC",
}

export type PlanEntryFinishedListRequestQueryParams = {
  order?: PlanEntryFinishedListingRequestOrder;
  taxiCorporationId?: string;
  driverId?: string;
  driverName?: string[];
  taxiName?: string[];
  planEntryNodes?: string[];
  startingNodeLabel?: string[];
  endingNodeLabel?: string[];
  startTimeSince?: Date;
  startTimeTo?: Date;
  endTimeSince?: Date;
  endTimeTo?: Date;
  humanId?: number[];
  involvedCargoLabels?: string[];
  isBilled?: boolean;
  cargoOrderId?: string;
  cargoOrderHumanId?: number;
  creationStart?: Date;
  creationEnd?: Date;
  limit?: number;
  offset?: number;
};

type PlanEntryFinishedListRequest = {
  order?: PlanEntryFinishedListingRequestOrder;
  taxiCorporationId?: string;
  driverId?: string;
  driverName?: string[];
  taxiName?: string[];
  planEntryNodes?: string[];
  startingNodeLabel?: string[];
  endingNodeLabel?: string[];
  startTimeSince?: Date;
  startTimeTo?: Date;
  endTimeSince?: Date;
  endTimeTo?: Date;
  humanId?: number[];
  involvedCargoLabels?: string[];
  isBilled?: boolean;
  cargoOrderId?: string;
  cargoOrderHumanId?: number;
  creationStart?: Date;
  creationEnd?: Date;
  limit?: number;
  offset?: number;
};

export default PlanEntryFinishedListRequest;
